'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.notify = notify;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mitt = require('mitt');

var _mitt2 = _interopRequireDefault(_mitt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emitter = (0, _mitt2.default)();

function notify() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  emitter.emit.apply(emitter, ['item:add'].concat(args));
}

var Notification = exports.Notification = function (_React$Component) {
  _inherits(Notification, _React$Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Notification);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      items: [],
      id: 0
    }, _this.timers = {}, _this.handleAdd = function (opts) {
      // notify('Hi') -> notify({ text: 'Hi' })
      if (typeof opts === 'string') {
        opts = { text: opts };
      }

      opts = _extends({
        timeout: 10000
      }, opts);

      var id = _this.state.id + 1;

      var item = {
        id: id,
        text: opts.text
      };

      _this.setState({
        items: [].concat(_toConsumableArray(_this.state.items), [item]),
        id: id
      });

      setTimeout(function () {
        _this.handleRemove(id);
      }, opts.timeout);
    }, _this.handleRemove = function (id) {
      _this.setState({
        items: _this.state.items.filter(function (item) {
          return item.id !== id;
        })
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Notification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      emitter.on('item:add', this.handleAdd);
      emitter.on('item:remove', this.handleRemove);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      emitter.off('item:add', this.handleAdd);
      emitter.off('item:remove', this.handleRemove);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        items: this.state.items,
        onClose: this.handleRemove
      });
    }
  }]);

  return Notification;
}(_react2.default.Component);